import React from "react";
import { Sparkles, Eye, FileText, ShieldAlert, Clock } from "lucide-react";
import { LegalPage } from "../components/LegalPage";

export const PrivacidadIAPage = () => {
  const sections = [
    {
      id: "1",
      icon: Eye,
      title: "1. Recopilación de Datos",
      body:
        "Cuando interactuás con OptiShield IA, recopilamos el historial del chat, tu identificador de usuario (si aplica, como tu ID de Discord o panel) y la hora de las interacciones para proveer contexto continuo a la conversación.",
    },
    {
      id: "2",
      icon: FileText,
      title: "2. Uso de la Información",
      body: "Los datos de las conversaciones se utilizan exclusivamente para:",
      bullets: [
        "Entregar y mejorar la respuesta de la IA a tus consultas.",
        "Identificar errores técnicos o problemas recurrentes en nuestros servicios de hosting para mejorar la plataforma.",
        "Detectar abuso o violaciones a nuestros Términos de Uso.",
      ],
    },
    {
      id: "3",
      icon: ShieldAlert,
      tag: "Precaución",
      title: "3. Datos Sensibles",
      body:
        "Te pedimos encarecidamente que no compartas información sensible (como contraseñas completas, claves privadas de SSH, tarjetas de crédito o tokens de acceso a bases de datos) directamente en el chat con la IA. Aunque los chats están cifrados en tránsito, el modelo procesa esta información en texto plano para poder responder.",
      callout: { variant: "warning", label: "⚠ Nunca compartas contraseñas, claves SSH, tokens o números de tarjeta en el chat." },
    },
    {
      id: "4",
      icon: Clock,
      title: "4. Retención de Datos",
      body:
        "Los historiales de conversación se almacenan de forma segura por un período de 30 días para fines de soporte técnico y control de calidad, tras los cuales son anonimizados o eliminados permanentemente.",
    },
  ];

  return (
    <LegalPage
      title="Privacidad - OptiShield IA | OptiShield X"
      breadcrumb={[
        { label: "Inicio", to: "/" },
        { label: "OptiShield IA", to: "/ia" },
        { label: "Privacidad" },
      ]}
      tag={{ icon: Sparkles, label: "Privacidad de OptiShield IA" }}
      headline={{ prefix: "Privacidad de", accent: "OptiShield IA" }}
      subtitle="Cómo protegemos y gestionamos los datos que compartís con nuestro asistente de IA."
      lastUpdated="Febrero 2026"
      sections={sections}
      ctaTitle="¿Querés saber más sobre la IA?"
      ctaDescription="Probá OptiShield IA gratis desde nuestro Discord oficial."
      ctaLinks={[
        { label: "Términos IA", to: "/terminos-ia", testId: "privacidad-ia-terminos-link" },
        { label: "Ir a OptiShield IA", to: "/ia", testId: "privacidad-ia-back-link" },
        { label: "Discord", href: "https://discord.gg/ExE6pGa4df", primary: true, testId: "privacidad-ia-discord-link" },
      ]}
      testIdPrefix="privacidad-ia"
    />
  );
};
